export class WizardButtonOptions {
  submitButtonText?: string = 'Submit';
  showSubmitButtonOnLastStep: boolean = true;
}
